import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import UserGroupPermissions from './UserGroupPermissions';

const mapStateToProps = state => ({
  permissions: state.accessControl.userGroup.appsPermissions.permissions,
  userGroupId: state.userGroups.details.userGroup.id,
  isLoading: state.accessControl.userGroup.appsPermissions.isLoading,
  failed: state.accessControl.userGroup.appsPermissions.failed,
  total: state.accessControl.userGroup.appsPermissions.total,
});

export default connect(mapStateToProps)(
  withTranslation('administration')(UserGroupPermissions),
);
